var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.047 15H1.044V4.987h3.003zM15 15h-3.003V9.684c0-1.374-.486-2.083-1.458-2.083-.795 0-1.28.399-1.501 1.152V15H6.035s.044-8.994 0-10.013h2.521l-.004 1.994h.044c.619-1.019 1.59-1.684 2.96-1.684 1.015 0 1.854.266 2.472 1.02C14.647 7.024 15 8 15 9.328zM4.091 2.506c0 .842-.706 1.507-1.545 1.507C1.706 4.013 1 3.348 1 2.506S1.707 1 2.546 1s1.545.665 1.545 1.506"
  })));
};
export default SvgLinkedin;